<template>
  <div>
    <div class="content">
      <div class="contentLeft">
        <Gangwei :id="id" :kaifang="kaifang" v-if="lxOn == 0" />
        <Linggong :id="id" v-if="lxOn == 1" />
      </div>
      <div class="contentRit">
        <div class="title">发布类型</div>
        <div class="leixing">
          <div
            class="box dis-cent"
            v-for="(item, index) in lxList"
            :class="lxOn == index ? 'on' : ''"
            @click="lxClick(index)"
          >
            {{ item }}
          </div>
        </div>
        <div class="text">备注: 岗位是正常招募员工，零工是寄件计时等工作</div>
      </div>
    </div>
    <div style="height: 300px;"></div>
  </div>
</template>

<script>
import Gangwei from "./gangwei.vue";
import Linggong from "./linggong.vue";


export default {
  components: {
    Gangwei,
    Linggong,
  },
  name: "",
  data() {
    return {
      lxOn: 0,
      lxList: ["岗位", "零工"],
      id:'',
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.kaifang = this.$route.query.kaifang;
    this.lxOn = this.$route.query.type;
  },
  methods: {
    lxClick(i) {
      this.lxOn = i;
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.content {
  width: 1280px;
  margin: auto;
  margin-top: 15px;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px 70px;
  display: flex;
  .contentLeft {
    width: 600px;
    .title {
      font-weight: 600;
      font-size: 20px;
      margin-bottom: 5px;
    }
    .text {
      color: #666;
      margin-bottom: 30px;
    }
    .box {
      display: flex;
      margin-bottom: 15px;
      .name {
        color: #666;
        width: 90px;
        text-align: right;
      }
      .mr5 {
        margin-top: 5px;
      }
      .txt {
        width: calc(100% - 90px);
        padding-left: 10px;
        box-sizing: border-box;
        font-size: 14px;
      }
      .inpBox {
        width: 500px;
        padding: 0 10px;
        height: 35px;
        margin-left: 10px;
        border-radius: 5px;
        box-sizing: border-box;
        border: 1px solid #ebebeb;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #9c9c9c;
        overflow: hidden;
        cursor: pointer;
        .seleTxt {
          width: calc(100% - 35px);
        }
        .enter {
          width: 35px;
          text-align: right;
          font-size: 14px;
        }
        input {
          width: 100%;
          height: 100%;
          color: #000;
        }
      }
      .selectBoxs {
        width: 500px;
        height: 35px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        margin-left: 10px;
        .cont {
          width: calc(33.33% - 10px);
          height: 100%;
          display: flex;
          align-items: center;
          box-sizing: border-box;
          border: 1px solid #ebebeb;
          border-radius: 5px;
          padding: 0 10px;
          color: #9c9c9c;
          cursor: pointer;
          .seleTxt {
            width: calc(100% - 35px);
          }
          .enter {
            width: 35px;
            text-align: right;
            font-size: 14px;
          }
        }
        .cont:last-child {
          margin-right: 0;
        }
        .gang {
          width: 10px;
        }
        .cha {
          width: 20px;
          font-size: 16px;
          position: relative;
          top: -1px;
        }
      }
      .selectYearBoxs {
        width: 500px;
        height: 35px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        margin-left: 10px;
        .cont {
          width: calc(50% - 7.5px);
          margin-right: 15px;
          height: 100%;
          display: flex;
          align-items: center;
          box-sizing: border-box;
          border: 1px solid #ebebeb;
          border-radius: 5px;
          padding: 0 10px;
          color: #9c9c9c;
          cursor: pointer;
          .seleTxt {
            width: calc(100% - 35px);
          }
          .enter {
            width: 35px;
            text-align: right;
            font-size: 14px;
          }
        }
        .cont:last-child {
          margin-right: 0;
        }
      }
      .zwCont {
        display: flex;
        align-items: center;
        width: 500px;
        padding: 0 10px;
        height: 35px;
        margin-left: 10px;
        .addBox {
          width: 70px;
          height: 30px;
          border-radius: 30px;
          border: 1px solid #ebebeb;
          box-sizing: border-box;
          color: #9c9c9c;
          margin-right: 10px;
          cursor: pointer;
        }
        .zwBox {
          height: 30px;
          background-color: #e9effa;
          padding: 0 15px 0 20px;
          border-radius: 30px;
          margin-right: 10px;
          .close {
            font-size: 12px;
            font-weight: 600;
            position: relative;
            top: 1px;
            margin-left: 7px;
            cursor: pointer;
          }
        }
      }
      .tareBox {
        height: 160px;
        width: 500px;
        margin-left: 10px;
        border-radius: 5px;
        box-sizing: border-box;
        border: 1px solid #ebebeb;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #9c9c9c;
        overflow: hidden;
        cursor: pointer;
        textarea {
          width: 100%;
          height: 100%;
          border: none;
          padding: 10px;
        }
      }
    }
  }
  .fbBox {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .btn {
      width: 90px;
      height: 40px;
      border-radius: 5px;
      background-color: #147ee0;
      color: #fff;
      cursor: pointer;
    }
  }
  .contentRit {
    width: calc(100% - 600px);
    padding-left: 60px;
    box-sizing: border-box;
    .title {
      font-weight: 600;
      font-size: 20px;
      margin-bottom: 5px;
    }
    .leixing {
      display: flex;
      margin-top: 15px;
      .box {
        width: calc(50% - 10px);
        height: 50px;
        margin-right: 20px;
        border: 1px solid #ebebeb;
        border-radius: 5px;
        cursor: pointer;
      }
      .box:last-child {
        margin-right: 0;
      }
      .on {
        color: #fff;
        background-color: #147ee0;
      }
    }
    .text {
      margin-top: 15px;
      color: #9c9c9c;
    }
  }
}
</style>
